import React from 'react';
import { publications, ME } from './publications';

function Authors({ authors }) {
  return (
    <p className="pub-authors">
      {authors.map((a, i) => (
        <React.Fragment key={i}>
          {i > 0 && ', '}
          <span className={a === ME ? 'pub-me' : ''}>{a}</span>
        </React.Fragment>
      ))}
    </p>
  );
}

export default function PublicationsPage() {
  return (
    <div className="page">
      <h1 className="page-title">Publications</h1>
      <div className="pub-list">
        {publications.map((p) => (
          <article key={p.id} className="pub-card">
            <h3 className="pub-title">{p.title}</h3>
            <Authors authors={p.authors} />
            <p className="pub-venue">{p.venue}{String(p.venue).includes(String(p.year)) ? '' : ` · ${p.year}`}</p>
            {p.abstract && <p className="pub-abstract">{p.abstract}</p>}
            <div className="pub-links">
              {p.links.arxiv && <a href={p.links.arxiv} target="_blank" rel="noreferrer">arXiv</a>}
              {p.links.pdf && <a href={p.links.pdf} target="_blank" rel="noreferrer">PDF</a>}
              {p.links.code && <a href={p.links.code} target="_blank" rel="noreferrer">Code</a>}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
